module.exports = {
	"base": {
		"welcome": " %{name}さん、Mulligans へようこそ！",
		"user": "ユーザー情報",
		"devices": "デバイス",
		"refunds": "返金",
		"resources": "リソース",
		"transactions": "注文と返品",
		"email": "電子メール",
		"password": "パスワード",
		"save": "保存",
		"sign-out": "サインアウト",
		"cancel": "キャンセル",
		"close": "閉じる",
		"learn-more": "詳細を表示",
		"required": "必須",
		"support": "サポート",
		"bookshelf": "本棚",
		"launch": "起動",
		"download": "ダウンロード",
		"details": "詳細",
		"cannot-be-blank": "%{field}を空白にすることはできません。",
		"saving": "保存しています...",
		"done": "完了",
		"failed": "失敗",
		"copy": "コピー"
	},
	"signin": {
		"login-failure": "メール アドレスまたはパスワードが正しくありません",
		"welcome-large": "%{brand}<span class='inner'>Account Center へようこそ</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "サインイン",
		"forgot-password": "パスワードを忘れた場合",
		"new-to-vst": "%{brand}を初めてご利用の場合",
		"create-account": "アカウントを作成",
		"signing-in": "サインインしています...",
		"signin-failed": "サインインに失敗しました"
	},
	"transactions": {
		"price": "価格",
		"excluded": "(Excluding tax)",
		"quantity": "数量",
		"confirmation#": "確認番号",
		"payment": "支払い",
		"purchased": "購入済み",
		"purchase-details": "購入詳細",
		"subtotal": "小計",
		"total": "合計",
		"tax": "税",
		"loading": "お客様のトランザクションを読み込んでいます...",
		"no-purchases": "購入履歴がありません。",
		"seller-vat": "売り主の付加価値税",
		"total-vat": "支払%{vat}合計",
		"portion": "%{subTax} Tax %{rate}%",
		"vat-disclosure": "Price Includes %{vat}",
		"purchases": "購入",
		"refunded-items": "返金済みアイテム",
		"book-title": "ブック タイトル",
		"refund-details": "返金の詳細",
		"print-receipt": "領収証を印刷",
		"request-refund": "返金をリクエスト",
		"expired": "期限切れ",
		"expires-in": "有効期限: %{date}",
		"details-refund": "詳細と返金",
		"modal": {
			"cant-refund-title": "返金不可",
			"cant-refund": "以下のいずれかまたは複数の理由により、ブックの返金ができません。",
			"cant-refund-1": "ブックの閲覧済み部分が多すぎるため。",
			"cant-refund-2": "購入日からすでに14日以上が経過しているため。",
			"cant-refund-3": "オンライン リソース コードが使用済みであるため。",
			"cant-refund-4": "すでに返金済みのブックであるため。",
			"cant-refund-5": "コードはすべて引き換え済みか、返金済みです。",
			"cant-refund-6": "購入日からすでに30日以上が経過しているため。",
			"cant-refund-support": "%{brand}の返金ポリシーにご不明な点がございましたら、<a href='%{support_url}' target='_blank'>サポート</a>にお問い合わせください。"
		},
		"license": {
			"perpetual": "オンライン アクセスは有効期限切れになりません",
			"days": "%{days}日間アクセス"
		}
	},
	"devices": {
		"description": "%{brand} は、同時に <span>%{desktop}</span> 台のコンピュータと <span>%{mobile}</span> 台のモバイル/タブレット デバイスをアクティベートすることを許可しています。",
		"loading": "デバイスを読み込み中です",
		"no-active": "アクティブなデバイスはありません。",
		"deactivate": "非アクティブ化"
	},
	"user": {
		"personal-information": "個人情報",
		"security-information": "セキュリティ情報",
		"notifications": "通知",
		"first-name": "名",
		"last-name": "姓",
		"change-password-title": "パスワードの変更",
		"current-password": "現在のパスワード",
		"new-password": "新しいパスワード",
		"security-password": "パスワード",
		"confirm-new-password": "新しいパスワードの確認",
		"security-question": "セキュリティの質問",
		"security-info-change": "変更",
		"question": "質問",
		"answer": "回答",
		"notifications-text": "アカウントの活動状況や最新の製品情報、特典など、最新情報をメールで受け取る",
		"loading": "ポチがユーザー情報を取得中です。もう少しお待ち下さい🐶",
		"change-password-text": "パスワードは8文字以上で、大文字、小文字、記号が含まれている必要があります。",
		"email-locked": "電子メール アドレスはロックされています",
		"email-locked-description": "電子メール アドレスを変更する権限がありません。",
		"email-locked-more": "管理者に連絡してください。",
		"security-question6": "好きなスポットは?",
		"security-question7": "好きなアイスクリームのフレーバーは?",
		"security-question8": "好きなペットの名前は?",
		"security-question9": "小さい頃なりたかった職業は?",
		"security-question10": "好きな先生の苗字は?",
		"new-password-failure": "パスワードが要件を満たしていません",
		"confirm-password-failure": "パスワードは一致する必要があります",
		"new-password-tooltip": "8文字以上で、大文字、小文字、記号を含める必要があります。",
		"enter-valid-email": "有効なメール アドレスを入力してください。",
		"password-cannot-be-same": "古いパスワードと同じパスワードは使えません",
		"incorrect-password": "不正なパスワード",
		"complete-account": "Looks like you need to <a href='%{href}'>complete your account</a>.",
		"completing-allows": "Completing your account allows you to read books offline on our mobile apps and share notes and highlights with friends.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "付属",
		"access-codes": "アクセス コード",
		"print-on-demand": "オンデマンド印刷",
		"check-pod": "ブックのパブリッシャー印刷オプションをご確認ください。",
		"check-now": "今すぐチェック",
		"loading": "リソースをアップデートしています。しばらくお待ちください！",
		"in": "次の場所：",
		"access-code-intro": "アクセス コードは、コース コンテンツにオンライン アクセスするためのパスワードです。1度アイテムにコードを使用すると、返品できなくなります。アクセス コードの使用方法の詳細については、<a href='%{support_url}' target='_blank'>サポート</a>をご参照ください。",
		"expires": "有効期限",
		"expiration-message": "アクセス コードの使用手順が記載されています。",
		"copy-fail": "コピーできません。コードを選択して手動でコピーしてください。",
		"launch-site": "サイトを起動",
		"launch-book": "ブックを起動",
		"reveal-code": "コードを表示",
		"no-resources": "リソースがありません。",
		"no-access-codes": "アクセス コードがありません。",
		"no-ancillaries": "このタイトルには付属がありません",
		"name": "名前",
		"type": "種類",
		"size": "サイズ",
		"download-all": "すべてダウンロード",
		"back": "Back to resources"
	},
	"refunds": {
		"states": {
			"refunded": "返金済み",
			"unavailable": "返金不可"
		},
		"reasons": {
			"dropped": "コースを途中でやめた",
			"wrong": "コース内容に合ったブックではなかった",
			"print": "印刷版を購入することにした",
			"missing": "このブックにはコースで必要なもの（CD、ウェブ アクセス、ビデオなど）の一部が含まれていない",
			"other": "その他"
		},
		"bulk": {
			"policy": "以下の「返金を完了」ボタンをクリックすることにより、%{brand}の<a href='%{policy_url}' target='_blank'>返金ポリシー</a>に同意いたします。",
			"complete": "返金を完了",
			"view-details": "返金の詳細を表示",
			"success": "返金がリクエストされました。処理まで48時間お待ちください。",
			"failure": "何か問題が起きたようです。返金処理は完了しませんでした。",
			"retry": "もう一度お試しください",
			"support": "サポートへのお問い合わせ",
			"available-codes": "利用可能なコード",
			"codes-selected": "選択済みのコード",
			"download": "ダウンロード済みのコード",
			"partially-refunded": "一部返金済み",
			"pick-one": "返金を受けるにはコードを少なくとも1つ選択する必要があります"
		},
		"refund": "返金",
		"all": "すべて返金しますか?",
		"missing-reason": "続行するには理由を選択する必要があります",
		"missing-elaboration": "説明を入力してください",
		"policy": "以下の「返金リクエストを完了」ボタンをクリックすることにより、今後この %{brand} eTextbook を再購入した場合に、その eTextbook について返金をリクエストする資格を喪失することを了解します。返品ポリシーの全文を表示",
		"refunded": "返金済み",
		"sorry": "内容にご満足いただけず申し訳ありません。",
		"error": "何か問題が起きたようです",
		"error-explain": "返金処理ができませんでした。再試行してください。",
		"why": "理由を教えてください",
		"no-refunds": "返金されたアイテムはありません。",
		"select-codes": "返金するコードを選択してください:",
		"number": "いくつですか?",
		"back": "返金に戻る"
	},
	"purchases": {
		"back": "Back to purchases"
	},
	"global-bar": {
		"account": "アカウント設定"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/ja.json
 ** module id = 1014
 ** module chunks = 0
 **/